import { ChangeDetectionStrategy, Component, computed, inject, input, output } from '@angular/core';

import { LayerBloc } from '@connect-services/client/blocs/layer.bloc';
import { TitleComponent } from '@connect-services/client/components/field-intervention-title/title/title.component';
import { HasPermissionsService } from '@connect-services/client/services/has-permissions.service';
import { LayerEditService } from '@connect-services/client/services/layer-edit.service';
import { ButtonComponent, ButtonType } from '@connect-services/src/lib/components/button/button.component';
import { Layer, PermissionAliasEnum } from '@connect-services/src/sdk/api';
import { RessourcesModule } from '@ressources/client/ressources.module';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [ButtonComponent, RessourcesModule, TitleComponent],
    selector: 'app-project-settings-layer-detail-template',
    styleUrl: './project-settings-layer-detail-template.component.scss',
    templateUrl: './project-settings-layer-detail-template.component.html',
})
export class ProjectSettingsLayerDetailTemplateComponent {
    public readonly businessIdentifier = input<string>();
    public readonly canDelete = input<boolean>(true);
    public readonly canEditSymbology = input<boolean>(false);
    public deleteLayer = output<void>();
    public readonly deleteTooltip = input<string | undefined>(undefined);
    public goToPreviousPage = output<void>();
    public readonly hasAttributes = input<boolean>(false);
    public readonly subtitle = input<string>();
    public readonly symbologyDisabledTooltip = input<string>();
    public readonly title = input.required<string>();

    protected readonly ButtonType = ButtonType;
    protected readonly hasPermissionsService = inject(HasPermissionsService);
    protected readonly layerBloc = inject(LayerBloc);
    protected readonly layerEditService = inject(LayerEditService);
    protected readonly PermissionAliasEnum = PermissionAliasEnum;
    protected readonly shouldDisplaySubtitle = computed<boolean>(() => {
        return !(
            !this.layerBloc.value() ||
            this.layerBloc.value()!.type === Layer.TypeEnum.REFERENCE_DATA ||
            !this.subtitle()
        );
    });
    protected readonly symbologyTooltip = computed<string | undefined>(() => {
        if (this.symbologyDisabledTooltip()) {
            return this.symbologyDisabledTooltip();
        }

        return this.hasPermissionsService.checkPermissions([PermissionAliasEnum.MANAGE_LAYER])
            ? undefined
            : 'insufficientPermissions';
    });
}
